import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Packages
import PropTypes from 'prop-types';
import Axios from 'axios';
import { Buffer } from 'buffer';
import clsx from 'clsx';

const RenderImage = (props) => {
  const { imageId, defaultSrc, alt, refImage } = props;

  const navigate = useNavigate();

  const { payload_info } = useSelector(state => state.payload);
  const { survey_response } = useSelector(state => state.survey);

  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    let isMounted = true;

    if (imageId !== '' && imageId !== 'None') {
      Axios.get(`${process.env.REACT_APP_SERVER_URL}/api/images/${imageId}/data`,{
        responseType: 'arraybuffer'
      })
      .then((res) => {
        let data = `data:${res.headers['content-type']};base64, ${Buffer.from(res.data, 'binary').toString('base64')}`;
  
        if (isMounted) setImgSrc(data);
      }).catch((err) => {
        if (isMounted) setImgSrc(defaultSrc);
      });
    }
    else {
      if (isMounted) setImgSrc(defaultSrc);
    }

    return () => isMounted = false;
  }, [imageId]);

  const onClickImage = () => {
    if (refImage === 'payload') {
      navigate(`/locations/${payload_info.location._id.$oid}/payloads/${payload_info._id.$oid}/image/${imageId}`);
    }
    else if (refImage === 'surveys') {
      const responseId = survey_response?._id?.$oid;
      if (responseId) {
        navigate(`/surveys/responses/${responseId}/image/${imageId}`);
      }
    }
  }

  const sizeClass = clsx({
    'ref-img': refImage === 'reference',
    'payload-img': refImage === 'payload' || refImage === 'fraud' || refImage === 'surveys',
  });

  if (imgSrc === null) {
    return (
      <div className={clsx('img-skeleton', sizeClass)} aria-label={alt} role='img'>
        <i className='bi bi-image'></i>
      </div>
    );
  }

  return (
    <img
      className={sizeClass}
      style={refImage === 'payload' || refImage === 'surveys' ? {cursor: 'pointer'} : null}
      src={imgSrc} alt={alt} onClick={onClickImage}
    />
  );
}

RenderImage.propTypes = {
  imageId: PropTypes.string.isRequired,
  defaultSrc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  refImage: PropTypes.string.isRequired
};
 
export default RenderImage;
